import React from 'react';
import styles from "./PaymentWayRow.scss";
import Radio from "../../common/primitives/Radio";
import helpers from "../../common/scss/helpers/_helpers.scss";
import ComponentAutoRenewMessage from "../ComponentAutoRenewMessage/ComponentAutoRenewMessage";
import {__t} from "../../common/lang/text-resource";


export default function PaymentCardRow({
										   cardData,
										   autoRenewChecked,
										   onChangeAutoRenew,
										   selected,
										   onChange,
										   hideComponentAutoRenewMessage
									   }) {

	const lang = SHVO.pageLang ?? 'bg';

	return (
	  <div className={`${styles.container} ${selected && styles.selected}`}>
		  <div data-layout="row gutter-none start">
			  <div data-layout="col 1">
				  <Radio
					name={'paymentWay'}
					value={cardData.id}
					label={''}
					id={cardData.id}
					checked={selected}
					labelClass={helpers.orderServiceName}
					onChange={onChange}/>
			  </div>
			  <div data-layout={`col 2 1@md text-right`}>
				  <label
					htmlFor={cardData.id}
					className={`${styles.icon} ${styles[cardData.cardName.toLowerCase()]}`}>&nbsp;</label>
			  </div>
			  <div data-layout={`col 9 10@md`}>
				  <label className={styles.cardLabel} htmlFor={cardData.id}>{__t('Банкова карта')}</label>
			  </div>

			  <div data-layout="col 12 margin-top--15" className={styles.cardDataRow}>
				  <div data-layout="row gutter-none start">
					  <div data-layout="col 4 3@md"
						   style={{marginRight: "-3px"}}
						   className={styles.cardDetailLabel}>
						  {__t('номер')}
					  </div>
					  <div data-layout={`col 8 9@md`} className={styles.cardDetail}>
						  {cardData.cardNumber}
					  </div>
				  </div>
			  </div>

			  <div data-layout="col 12 margin-top--smm" className={styles.cardDataRow}>

				  {lang === 'bg' && <div data-layout="row gutter-none start">
					  <div data-layout="col 3 2@md" className={`${styles.cardDetailLabel} ${styles.dateLabel}`}
						   style={{marginRight: "15px", marginLeft: "-15px"}}>
						  {__t('валидност')}
					  </div>
					  <div data-layout={`col 9 10@md padding-left--20`}
						   className={`${styles.cardDetail} ${styles.dateContainer}`}>
						  {cardData.date}
					  </div>
				  </div>}
				  {lang === 'en' && <div data-layout="row gutter-none start">
					  <div data-layout="col 4 3@md"
						   style={{marginRight: "-3px"}}
						   className={styles.cardDetailLabel}>
						  {__t('expiry')}
					  </div>
					  <div data-layout={`col 8 9@md`} className={styles.cardDetail}>
						  {cardData.date}
					  </div>
				  </div>}
			  </div>
			  {
				selected === true && hideComponentAutoRenewMessage === false &&
				<div data-layout="margin-top--smm row gutter-none start">
					<ComponentAutoRenewMessage
					  autoRenewChecked={autoRenewChecked}
					  onChangeAutoRenew={onChangeAutoRenew}/>
				</div>
			  }

		  </div>

	  </div>
	)
}